import React from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import {connect} from "react-redux";
import { withStyles, TableContainer, Table, TableBody, TableRow, TableCell, Radio } from "@material-ui/core";
import TableHeader from '../../../../../Common/TableHeader';
import t from "../../../../../../languages/pl";
import { notArrayOrEmpty } from '../../../../../../utils/helpers';
import NoData from '../../../../../Common/NoDataRow';
import guid from '../../../../../../utils/guid';

const useStyles = theme => ({
    table: {
        paddingTop: theme.spacing(1),
        maxHeight: "68vh"
    },
    cell: {
        textAlign: "center",
        padding: theme.spacing(1)
    }
});

const tableHeader = [t.select, t.name, t.perHour, t.from1To3Days, t.from4to7Days, t.above7Days, t.ratePerKilometerAboveLimit];

const CarPricingTable = props => {
    const { classes, pricingList, selectedPricingId, onRadioClick } = props;

    const handleRadioClick = (pricingId) => {
        if(pricingId !== selectedPricingId.cennik_id){
            onRadioClick(pricingId);
        }
    }

    const printTable = data => {
        if (notArrayOrEmpty(data))
            return <NoData colSpan={7} />;
        return data.map(row => (
            <TableRow key={guid()}>
                <TableCell className={classes.cell}>
                    <Radio
                        className={classes.radio}
                        checked={row.cennik_id === selectedPricingId.cennik_id}
                        onClick={() => handleRadioClick(row.cennik_id)}
                    />
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.nazwa}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_godzinna}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_1_3dni}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_4_7dni}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_tygodniowa}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_pow_limit}
                </TableCell>
            </TableRow>
        ));
    };

    return (
        <TableContainer className={classes.table}>
            <Table stickyHeader>
                <TableHeader data={tableHeader} />
                <TableBody>
                    {printTable(pricingList)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

CarPricingTable.propTypes = {
    classes: PropTypes.object,
    //pricingList: PropTypes.array,
    onRadioClick: PropTypes.func
};

const mapStateToProps = state => ({
    pricingList: state.rentReducer.pricing,
});

export default compose(
    withStyles(useStyles),
    connect(mapStateToProps)
)(CarPricingTable);
